<template>
    <div class="stream-prop">
        <span class="stream-prop__label">Название:</span>

        <template v-if="isAccessAllow">
            <EditText
                v-if="isEdit"
                cancel-title="Удалить"
                v-model:trim="editable"
                v-on:apply="onSaveEdit"
                v-on:cancel="onCancelEdit"
            />
            <label v-else class="d-flex align-items-center mb-0">
                <div class="stream-prop__value">
                    <span>{{ stream.name }}</span>

                    <Icon
                        id="edit"
                        class="mr-1"
                        title="Редактировать"
                        @click="isEdit = true"
                    />
                </div>
            </label>
        </template>
        <div v-else class="stream-prop__value">{{ stream.name }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import EditText from "@common/vue/components/form/EditText";

export default {
    name: "StreamName",
    components: {EditText},
    props: ['isAccessAllow'],
    computed: {
        ...mapState({
            stream: state => state.planUrl.selectedStream,
        }),
    },
    data() {
        return {
            isEdit: false,
            editable: ''
        };
    },
    watch: {
        stream() {
            this.editable = this.stream.name;
        }
    },
    methods: {
        onSaveEdit(name) {
            this.$store.dispatch('updatePlanUrlStream', {
                streamId: this.stream.id,
                field: 'name',
                value: this.editable,
            })
            .then(() => {
                this.$store.dispatch('fetchPlanUrlTaskStreamList');
                this.isEdit = false;
            });
        },
        onCancelEdit() {
            this.editable = this.stream.name;
            this.isEdit = false;
        },
    }
}
</script>
